export const ClientAdvantageBulletPoints = {
    title: "Client Advantages",
    sections: [
      "Adapt to market changes: Large losses require outsized returns to recover; we use technology to make timely adjustments to avoid unnecessary risk.",
      "Beta adjustments: By changing exposure levels (beta), we allow the portfolio to participate more or less, depending on market conditions.",
      "Systematic, not radical: Adjustments are thoughtful and systematic, aimed at overweighting or underweighting positions—not about taking big risks.",
          "Flexibility and proactivity: Instead of sitting idle, we make proactive changes to protect and grow the portfolio.",
    ]
}

export const MarketBulletPoints = {
    title: "Volatility In the Stock Market",
    sections: [
      "Large losses require outsized returns to recover ",
      "Recovery Times Can Be Long",
      "Stock and Bonds can be Correlated",
          "Flexibility and proactivity: Instead of sitting idle, we make proactive changes to protect and grow the portfolio.",
    ]
}

export const FiniatSolutionBulletPoints = {
    title: "How This Solution Helps",
    sections: [
      "Personalized - Client Risk Tolerance Asset Allocation is still in place",
      "Technology makes adjustments to both the equity and fixed-income ETFs looking for the strongest areas of the market and tries to avoid the weakest",
      "Adjustments are thoughtful and systematic, aimed at overweighting or underweighting positions, such as domestic and international, value and growth, or small, mid, and large—not about taking big risks",
    ]
}